module.exports = __webpack_public_path__ + "img/BG_Location.6f171fca.svg";